import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const withThemeChange = (WrappedComponent) => {
  const ThemeChangeDecorator = (props) => {
    const [checked, setChecked] = useState(true);
    useEffect(() => {
      let theme = localStorage.getItem("theme");
      setChecked(theme == "theme-light");
    }, []);

    const setTheme = (themeName) => {
      window.theme.composite.SetTheme(themeName);
    };

    const toggleTheme = () => {
      if (checked) {
        setTheme("theme-dark");
      } else {
        setTheme("theme-light");
      }
      setChecked(!checked);
    };
    return (
      <WrappedComponent {...props} checked={checked} onChange={toggleTheme} />
    );
  };
  return ThemeChangeDecorator;
};

export default withThemeChange;
